import CustomElement from '~utilities/custom-element';

class BackgroundVideo extends CustomElement {
	constructor() {
		super();
	}
	
	template() {
		return `
      <div class="c-background-video backgroundVideo" js-background-video>
        <video autoplay muted playsinline style="user-select: none;" loop>
          <source src="https://player.vimeo.com/progressive_redirect/playback/927123513/rendition/720p/file.mp4?loc=external&log_user=0&signature=f7c3f0f22d011d55c6e46514609834dc140cbc63b69bbed13887f5a38abb70c6" type="video/mp4" width="100%">
        </video>
      </div>
		`;
	}

	callback() {
		super.callback();
	}
}

export default BackgroundVideo;